export const awsConfig = {
  aws_cognito_region: process.env.REACT_APP_AWS_APPSYNC_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_COGNITO_USER_POOL_CLIENT_ID,
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_APPSYNC_GRAPHQLAPI_URL,
  aws_appsync_region: process.env.REACT_APP_AWS_APPSYNC_REGION,
};
